import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NovidadeSistemaService } from '../../services/novidadeSistema.service';
import { ToastService } from '../../../../shared/components/toast/services/toast.service';
import { NovidadeSistema } from '../../model/NovidadeSistema.model';
import { SectionContainerComponent } from '../../../../shared/components/section-container/section-container.component';
import { CardFiltroComponent } from '../../../../shared/components/card-filtro/card-filtro.component';
import { CardGenericComponent } from '../../../../shared/components/cards/card-generic/card-generic.component';
import { CommonModule, DatePipe } from '@angular/common';
import { NovidadeCategoriaService } from '../../services/categoria.service';
import { NovidadeCategoria } from '../../model/NovidadeCategoria.model';
import { SkeletonCardGenericComponent } from '../../../../shared/components/skeleton/skeleton-card-generic/skeleton-card-generic.component';
import { TranslateModule } from '@ngx-translate/core';
import { DataUtcPipe } from '../../../../shared/utils/Pipes/data-utc.pipe';

@Component({
  selector: 'app-article',
  imports: [SectionContainerComponent, TranslateModule, SkeletonCardGenericComponent, CommonModule, CardFiltroComponent, CardGenericComponent, DatePipe, DataUtcPipe],
  templateUrl: './article.component.html',
  styleUrl: './article.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ArticleComponent implements OnInit {
  idNovidade: string = ''
  novidadeSistema?: NovidadeSistema;
  categorias: Array<NovidadeCategoria> = new Array;
  dadosProntos: boolean = false;


  constructor(
    private _activateRoute: ActivatedRoute,
    private _router: Router,
    private _feedService: NovidadeSistemaService,
    private _toasService: ToastService,
    private _novidadeCategoriaService: NovidadeCategoriaService) {

  }

  ngOnInit(): void {
    this.load();
  }

  private load() {
    this.idNovidade = this._activateRoute.snapshot?.paramMap?.get('id') || '';

    if (this.idNovidade.length <= 0) {

      this._toasService.show("Desculpe mas não foi possível encontrar um rota com este Id.", "info")

      setTimeout(() => {
        this._router.navigate(['/novidades/feed-novidades'])
      }, 2000)

    }

    else {

      this._feedService.getById(Number(this.idNovidade)).subscribe({

        next: (data) => {

          if (data != null) {

            this._novidadeCategoriaService.get().subscribe(categoriasData => {
              this.categorias = categoriasData
            })

            this.novidadeSistema = data;

            this.dadosProntos = true;

          }

          else {

            this._toasService.show("Desculpe mas não foi posível encontrar uma novidade com este Id.", "error")

            setTimeout(() => {
              this._router.navigate(['/novidades/feed-novidades'])
            }, 2000)

          }

        }, error: () => {

          this._toasService.show("Desculpe mas não foi posível encontrar uma novidade com este Id.", "error")

          setTimeout(() => {
            this._router.navigate(['/novidades/feed-novidades'])
          }, 2000)
        }
      })
    }
  }


  voltarFeed() {
    this._router.navigate(['/novidades/feed-novidades'])
  }
}
